<template>
    <v-row>
        <v-col cols='12' class="px-0">
            <v-card>
                <v-card-text>
                    <v-row justify="center" align="center">
                        <v-col cols="6">
                            <h2>Personal Details</h2>
                        </v-col>
                        <v-col cols="6" class="text-right">
                            <v-chip v-if="user.isActive" class="green white--text">Account Active</v-chip>
                            <!-- <v-chip v-if="!user.isActive" class="green white--text">Account Active</v-chip> -->
                            <!-- <v-btn rounded small class="primary ml-2">Reset Password</v-btn> -->
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-text-field
                            disabled
                            label="Name"
                            v-model="user.name"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-text-field
                            disabled
                            label="Email"
                            v-model="user.email"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-text-field
                            disabled
                            label="Mobile"
                            v-model="user.mobile"
                            >
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-card class="mt-4">
                <v-card-text>
                    <v-row>
                        <v-col cols="12">
                            <h2>Contact Support</h2>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <v-text-field
                            label="Issue"
                            v-model="comment"
                            >
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-btn rounded small class="primary">Submit</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
export default {
    props:['user', 'agencyProfile'],
    data: () => ({
        comment:'',
        reason:''
    })
}
</script>